import { useEffect, useState } from 'react';
import { EmployeeVacationDays } from '../models/SummaryInterfaces';
import axios from 'axios';
import { AxiosError } from 'axios';

export enum VacationRequestType {
  New = 'new',
  Cancel = 'cancel',
}
export const useEmployeeVacationDays = (year?: number) => {
  const [vacationPeriod, setVacationPeriod] = useState<EmployeeVacationDays>();
  const [loadingVacationPeriod, setLoadingVacationPeriod] =
    useState<boolean>(false);
  const [vacationPeriodNextYear, setVacationPeriodNextYear] =
    useState<EmployeeVacationDays>(null);
  const [vacationPeriodPrevYear, setVacationPeriodPrevYear] =
    useState<EmployeeVacationDays>(null);

  const getSummary = async (
    bonusDays = 0,
    paidDays = 0,
    requestType = VacationRequestType.New
  ) => {
    try {
      setLoadingVacationPeriod(true);
      const { data } = await axios.get(
        `api/employee-vacation-periods/my/${year}`
      );
      const { data: dataNextYear } = await axios.get(
        `api/employee-vacation-periods/my/${year + 1}`
      );
      const { data: dataPrevYear } = await axios.get(
        `api/employee-vacation-periods/my/${year - 1}`
      );
      const requestTypeisNew = requestType === VacationRequestType.New;
      const isDataInPreviousYear = dataPrevYear.length === 0;
      const isDataInNextYear = dataNextYear.length === 0;
      setVacationPeriodPrevYear(isDataInPreviousYear ? null : dataPrevYear);
      setVacationPeriodNextYear(isDataInNextYear ? null : dataNextYear);

      setVacationPeriod({
        ...data,
        new_requestedbasepaiddays: requestTypeisNew
          ? data.new_requestedbasepaiddays + paidDays
          : data.new_requestedbasepaiddays - paidDays,
        new_requestedbonuspaiddays: requestTypeisNew
          ? data.new_requestedbonuspaiddays + bonusDays
          : data.new_requestedbonuspaiddays - bonusDays,
        new_remainingbasepaiddays: requestTypeisNew
          ? data.new_remainingbasepaiddays - paidDays
          : data.new_remainingbasepaiddays + paidDays,
        new_remainingbonuspaiddays: requestTypeisNew
          ? data.new_remainingbonuspaiddays - bonusDays
          : data.new_remainingbonuspaiddays + bonusDays,
      });
    } catch (err) {
      const error = err as AxiosError;
      console.error(error.message ?? error.message);
    } finally {
      setLoadingVacationPeriod(false);
    }
  };

  useEffect(() => {
    getSummary();
  }, [year]);

  return {
    vacationPeriod,
    loadingVacationPeriod,
    getSummary,
    vacationPeriodNextYear,
    vacationPeriodPrevYear,
  };
};
